import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";

const StorefrontCategoryIntro = ({ config }) => {
  if (!config?.enabled) return null;

  const eyebrow = String(config.eyebrow || "").trim();
  const title = String(config.title || "").trim();
  const text = String(config.text || "").trim();
  const buttonText = String(config.buttonText || "").trim();
  const backgroundColor = /^#[0-9a-f]{6}$/i.test(config.backgroundColor || "")
    ? config.backgroundColor
    : "#f1f5f9";
  const textColor = /^#[0-9a-f]{6}$/i.test(config.textColor || "")
    ? config.textColor
    : "#1e293b";
  const alignment = ["left", "center", "right"].includes(config.alignment)
    ? config.alignment
    : "left";
  const buttonLink = String(config.buttonLink || "/shop").trim();
  const style = {
    "--category-intro-background": backgroundColor,
    "--category-intro-text": textColor,
    "--category-intro-alignment": alignment,
  };

  const button = buttonText ? (
    buttonLink.startsWith("/") && !buttonLink.startsWith("//") ? (
      <Link className="shop-category-intro-button" to={buttonLink}>
        {buttonText} <FiArrowRight aria-hidden="true" />
      </Link>
    ) : (() => {
        try {
          if (new URL(buttonLink).protocol !== "https:") return null;
          return (
            <a
              className="shop-category-intro-button"
              href={buttonLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {buttonText} <FiArrowRight aria-hidden="true" />
            </a>
          );
        } catch (error) {
          return null;
        }
      })()
  ) : null;

  if (!eyebrow && !title && !text && !button) return null;

  return (
    <section
      className="shop-category-intro"
      style={style}
      aria-label={title || "Store announcement"}
    >
      <div className="shop-category-intro-copy">
        {eyebrow && <span className="shop-category-intro-eyebrow">{eyebrow}</span>}
        {title && <h2>{title}</h2>}
        {text && <p>{text}</p>}
      </div>
      {button}
    </section>
  );
};

export default StorefrontCategoryIntro;
